import { render, staticRenderFns } from "./RequestLogNew.vue?vue&type=template&id=72877a4a&"
import script from "./RequestLogNew.vue?vue&type=script&lang=js&"
export * from "./RequestLogNew.vue?vue&type=script&lang=js&"
import style0 from "./RequestLogNew.vue?vue&type=style&index=0&id=72877a4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports